
import axios from 'axios'
import { ENDPOINT } from '@/shared/constants'

const AXIOSAPI = axios.create({
  baseURL: '/'
})

AXIOSAPI.interceptors.response.use(response => {
  return response
}, function (error) {
  if (error.response.status === 401) {
    var ref = window.location.href
    var splitRef = ref.split('#/')
    var currentPath = splitRef[1]
    var basePath = splitRef[0]
    if (currentPath.includes('referer=')) {
      // In case of a double redirect, take the first one.
      currentPath = currentPath.split('referer=')[1]
    }
    var path = basePath + '#/login?referer=' + currentPath
    window.location.href = path
  }
  return Promise.reject(error)
})

class ApiRequests {
  static loginPost (data) {
    var url = ENDPOINT + 'auth/login'
    return AXIOSAPI.post(url, data)
  }

  static logoutPost () {
    var url = ENDPOINT + 'auth/logout'
    return AXIOSAPI.post(url)
  }

  static verifyEmail (token) {
    var url = ENDPOINT + 'auth/verifyemail'
    var data = {}
    data.token = token
    return AXIOSAPI.post(url, data)
  }

  static actionApprove (id) {
    var url = ENDPOINT + 'actions/' + id + '/approve'
    return AXIOSAPI.post(url)
  }

  static actionDeny (id) {
    var url = ENDPOINT + 'actions/' + id + '/deny'
    return AXIOSAPI.post(url)
  }

  static actionQuery (params) {
    var url = ENDPOINT + 'actions'
    return AXIOSAPI.get(url, { params: params })
  }

  static billingPlanQuery () {
    var url = ENDPOINT + 'billingplans'
    return AXIOSAPI.get(url)
  }

  static eventQuery (params) {
    var url = ENDPOINT + 'events'
    return AXIOSAPI.get(url, { params: params })
  }

  static groupQuery (params) {
    var url = ENDPOINT + 'groups'
    return AXIOSAPI.get(url, { params: params })
  }

  static interestCreate (data) {
    var url = ENDPOINT + 'interests'
    return AXIOSAPI.post(url, data)
  }

  static interestDelete (id) {
    var url = ENDPOINT + 'interests/' + id
    return AXIOSAPI.delete(url)
  }

  static interestGet (id) {
    var url = ENDPOINT + 'interests/' + id
    return AXIOSAPI.get(url)
  }

  static interestQuery (params) {
    var url = ENDPOINT + 'interests'
    return AXIOSAPI.get(url, { params: params })
  }

  static interestSave (data) {
    var url = ENDPOINT + 'interests/' + data._id
    return AXIOSAPI.put(url, data)
  }

  static interestDefaultCreate (data) {
    var url = ENDPOINT + 'interestdefaults'
    return AXIOSAPI.post(url, data)
  }

  static interestDefaultDelete (id) {
    var url = ENDPOINT + 'interestdefaults/' + id
    return AXIOSAPI.delete(url)
  }

  static interestDefaultGet (id) {
    var url = ENDPOINT + 'interestdefaults/' + id
    return AXIOSAPI.get(url)
  }

  static interestDefaultQuery (params) {
    var url = ENDPOINT + 'interestdefaults'
    return AXIOSAPI.get(url, { params: params })
  }

  static interestDefaultSave (data) {
    var url = ENDPOINT + 'interestdefaults/' + data._id
    return AXIOSAPI.put(url, data)
  }

  static logDelete (id) {
    var url = ENDPOINT + 'logs/' + id
    return AXIOSAPI.delete(url)
  }

  static logGet (id) {
    var url = ENDPOINT + 'logs/' + id
    return AXIOSAPI.get(url)
  }

  static logGetMeta (id) {
    var url = ENDPOINT + 'logs/' + id + '/meta'
    return AXIOSAPI.get(url)
  }

  static logQuery (params) {
    var url = ENDPOINT + 'logs'
    return AXIOSAPI.get(url, { params: params })
  }

  static organizationCreate (data) {
    var url = ENDPOINT + 'organizations'
    return AXIOSAPI.post(url, data)
  }

  static organizationGet (id) {
    var url = ENDPOINT + 'organizations/' + id
    return AXIOSAPI.get(url)
  }

  static organizationQuery (params) {
    var url = ENDPOINT + 'organizations'
    return AXIOSAPI.get(url, { params: params })
  }

  static organizationSave (data) {
    var url = ENDPOINT + 'organizations/' + data._id
    return AXIOSAPI.put(url, data)
  }

  static passwordReset (data) {
    var url = ENDPOINT + 'auth/passwordreset'
    return AXIOSAPI.post(url, data)
  }

  static passwordResetRequest (data) {
    var url = ENDPOINT + 'auth/passwordresetrequest'
    return AXIOSAPI.post(url, data)
  }

  static siteCreate (data) {
    var url = ENDPOINT + 'sites'
    return AXIOSAPI.post(url, data)
  }

  static siteDelete (id) {
    var url = ENDPOINT + 'sites/' + id
    return AXIOSAPI.delete(url)
  }

  static siteGet (id) {
    var url = ENDPOINT + 'sites/' + id
    return AXIOSAPI.get(url)
  }

  static sitePlanPut (id, body) {
    var url = ENDPOINT + 'sites/' + id + '/plan'
    return AXIOSAPI.put(url, body)
  }

  static siteUserAdd (id, body) {
    var url = ENDPOINT + 'sites/' + id + '/users'
    return AXIOSAPI.post(url, body)
  }

  static siteUserImport (id, body) {
    var url = ENDPOINT + 'sites/' + id + '/import'
    return AXIOSAPI.post(url, body)
  }

  static siteUserUpdate (sid, uid, body) {
    var url = ENDPOINT + 'sites/' + sid + '/users/' + uid
    return AXIOSAPI.put(url, body)
  }

  static siteUserRemove (sid, uid) {
    var url = ENDPOINT + 'sites/' + sid + '/users/' + uid
    return AXIOSAPI.delete(url)
  }

  static siteQuery (params) {
    var url = ENDPOINT + 'sites'
    return AXIOSAPI.get(url, { params: params })
  }

  static siteSave (data) {
    var url = ENDPOINT + 'sites/' + data._id
    return AXIOSAPI.put(url, data)
  }

  static userQuery (params) {
    var url = ENDPOINT + 'users'
    return AXIOSAPI.get(url, { params: params })
  }

  static userGet (id) {
    var url = ENDPOINT + 'users/' + id
    return AXIOSAPI.get(url)
  }
}

export default ApiRequests
